import { render, staticRenderFns } from "./KarsilastirmaDataTableHafta.vue?vue&type=template&id=7cfde081&scoped=true"
import script from "./KarsilastirmaDataTableHafta.vue?vue&type=script&lang=ts"
export * from "./KarsilastirmaDataTableHafta.vue?vue&type=script&lang=ts"
import style0 from "./KarsilastirmaDataTableHafta.vue?vue&type=style&index=0&id=7cfde081&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cfde081",
  null
  
)

export default component.exports